import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { LOGO } from "@/data/exercises";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [receiptNo, setReceiptNo] = useState("");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      if (!sessionId) { setState("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.paid) { setState("paid"); setReceiptNo(data.receipt_no || ""); return; }
        if (data.payment_status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries >= 6) { setState("error"); return; }
      timer = setTimeout(poll, 1800);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-6 font-care">
      <div className="w-full max-w-md bg-white rounded-3xl border border-gray-200 shadow-sm p-8 text-center" data-testid="payment-success-card">
        <img src={LOGO} alt="Passerelle" className="h-12 w-auto mx-auto mb-6" />
        {state === "checking" && (
          <div data-testid="payment-checking">
            <Loader2 className="w-10 h-10 animate-spin text-emerald-700 mx-auto mb-4" />
            <p className="text-gray-600">Vérification de votre paiement…</p>
          </div>
        )}
        {state === "paid" && (
          <div data-testid="payment-paid">
            <CheckCircle2 className="w-14 h-14 text-emerald-600 mx-auto mb-4" />
            <h1 className="font-serif-display text-2xl font-normal text-gray-800 mb-2">Paiement réussi 🎉</h1>
            <p className="text-gray-500 mb-2">Votre abonnement est activé.</p>
            {receiptNo && <p className="text-sm text-emerald-700 font-semibold mb-6">Reçu n° {receiptNo}</p>}
            <Button onClick={() => navigate("/abonnement")} className="w-full h-12 rounded-xl bg-emerald-700 hover:bg-emerald-800" data-testid="payment-continue">
              Voir mon abonnement
            </Button>
          </div>
        )}
        {state === "error" && (
          <div data-testid="payment-error">
            <XCircle className="w-14 h-14 text-amber-500 mx-auto mb-4" />
            <h1 className="font-serif-display text-2xl font-normal text-gray-800 mb-2">Paiement non confirmé</h1>
            <p className="text-gray-500 mb-6">Si vous avez été débité, l'accès s'activera sous peu. Sinon, réessayez.</p>
            <Button onClick={() => navigate("/abonnement")} className="w-full h-12 rounded-xl bg-emerald-700 hover:bg-emerald-800" data-testid="payment-retry">
              Retour à l'abonnement
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
